import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=53b43dfa&scoped=true&"
import script from "./Weight.vue?vue&type=script&lang=js&"
export * from "./Weight.vue?vue&type=script&lang=js&"
import style0 from "./Weight.vue?vue&type=style&index=0&id=53b43dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b43dfa",
  null
  
)

export default component.exports